document.documentElement.classList.remove("no-js");

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-section-id]").forEach((section) => {
    const selectedDelivery = section.querySelector("[data-delivery-option].is-selected");
    if (selectedDelivery) updateDeliveryDate(section, selectedDelivery.dataset.deliveryOption);
    updateProductVariant(section);
  });
  restoreBrandMomentCards();
  initHeroCarousels();
});

document.addEventListener("click", (event) => {
  const openButton = event.target.closest("[data-menu-open]");
  const closeButton = event.target.closest("[data-menu-close]");
  const drawer = document.querySelector("[data-menu-drawer]");
  if (openButton && drawer) {
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("ff-menu-open");
  }
  if (closeButton && drawer) {
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("ff-menu-open");
  }

  const filterButton = event.target.closest("[data-filter-toggle]");
  if (filterButton) {
    const panel = filterButton.closest(".ff-plp")?.querySelector("[data-filter-panel]") || document.querySelector("[data-filter-panel]");
    if (panel) panel.hidden = !panel.hidden;
  }

  const sheetOpenButton = event.target.closest("[data-sheet-target]");
  if (sheetOpenButton) {
    const plp = sheetOpenButton.closest(".ff-plp");
    const targetName = sheetOpenButton.getAttribute("data-sheet-target");
    const targetSheet = plp ? plp.querySelector(`[data-mobile-sheet="${targetName}"]`) : null;
    if (targetSheet) {
      targetSheet.setAttribute("aria-hidden", "false");
      document.body.classList.add("ff-sheet-open");
    }
  }

  const sheetCloseButton = event.target.closest("[data-sheet-close]");
  if (sheetCloseButton) {
    const sheet = sheetCloseButton.closest("[data-mobile-sheet]");
    if (sheet) {
      sheet.setAttribute("aria-hidden", "true");
      if (!document.querySelector('[data-mobile-sheet][aria-hidden="false"]')) {
        document.body.classList.remove("ff-sheet-open");
      }
    }
  }

  const searchButton = event.target.closest("[data-search-toggle]");
  if (searchButton) {
    const header = searchButton.closest("[data-ff-header]");
    const form = header ? header.querySelector("[data-mobile-search]") : null;
    const input = form ? form.querySelector("input[type='search']") : null;
    if (form && input) {
      if (!header.classList.contains("is-searching")) {
        header.classList.add("is-searching");
        form.setAttribute("aria-hidden", "false");
        window.setTimeout(() => input.focus(), 20);
      } else if (input.value.trim()) {
        form.requestSubmit();
      } else {
        input.focus();
      }
    }
  }

  const viewMoreLink = event.target.closest("[data-view-more-link]");
  if (viewMoreLink) {
    event.preventDefault();

    const pagination = viewMoreLink.closest("[data-view-more]");
    const grid = document.querySelector("[data-products-grid]");
    if (!pagination || !grid || viewMoreLink.getAttribute("aria-busy") === "true") return;

    const originalText = viewMoreLink.textContent;
    viewMoreLink.setAttribute("aria-busy", "true");
    viewMoreLink.textContent = "Loading";

    fetch(viewMoreLink.href)
      .then((response) => response.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        const nextGrid = doc.querySelector("[data-products-grid]");
        const nextLink = doc.querySelector("[data-view-more-link]");

        if (nextGrid) {
          grid.insertAdjacentHTML("beforeend", nextGrid.innerHTML);
        }

        if (nextLink) {
          viewMoreLink.href = nextLink.href;
          viewMoreLink.textContent = originalText;
          viewMoreLink.removeAttribute("aria-busy");
        } else {
          pagination.remove();
        }
      })
      .catch(() => {
        viewMoreLink.textContent = originalText;
        viewMoreLink.removeAttribute("aria-busy");
      });
  }

  const deliveryOption = event.target.closest("[data-delivery-option]");
  if (deliveryOption) {
    const group = deliveryOption.closest("[role='group']");
    const section = deliveryOption.closest("[data-section-id]");

    if (group) {
      group.querySelectorAll("[data-delivery-option]").forEach((button) => button.classList.remove("is-selected"));
    }

    deliveryOption.classList.add("is-selected");
    updateDeliveryDate(section, deliveryOption.dataset.deliveryOption);
    if (section) updateProductVariant(section);
  }
});

function updateDeliveryDate(section, deliveryValue) {
  if (!section) return;
  const deliveryDate = section.querySelector("[data-delivery-date]");
  const dateMap = {
    "18-20 Days": "18 Jun - 20 Jun",
    "3-5 Days": "5 Jun - 12 Jun",
    "Next Day": "3 Jun - 5 Jun",
    "1-3 Days": "3 Jun - 5 Jun",
  };

  if (deliveryDate) deliveryDate.textContent = dateMap[deliveryValue] || deliveryValue;
}

document.addEventListener("change", (event) => {
  const mobileSortInput = event.target.closest('.ff-mobile-sort-list input[name="sort_by"]');
  if (mobileSortInput) {
    const form = mobileSortInput.closest("form");
    if (form) form.requestSubmit();
    return;
  }

  const optionInput = event.target.closest("[data-product-form] input[type='radio'], [data-product-form] select[name^='options']");
  if (!optionInput) return;

  const section = optionInput.closest("[data-section-id]");
  if (section) updateProductVariant(section);
});

function updateProductVariant(section) {
  const form = section.matches("[data-product-form]") ? section : section.querySelector("[data-product-form]");
  if (!form) return;
  const root = form.closest(".ff-pdp") || section;

  const sectionId = form.getAttribute("data-section-id");
  const variantsScript = document.querySelector(`[data-product-variants="${sectionId}"]`);
  if (!variantsScript) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsScript.textContent);
  } catch {
    return;
  }

  let selectedOptions = Array.from(form.querySelectorAll(".ff-option")).map((fieldset) => {
    const checked = fieldset.querySelector("input[type='radio']:checked");
    return checked ? checked.value : "";
  });

  if (!selectedOptions.length) {
    selectedOptions = Array.from(form.querySelectorAll("[data-option-position]")).reduce((options, input) => {
      const position = Number(input.dataset.optionPosition) - 1;
      if (Number.isNaN(position)) return options;

      if (input.matches("[data-delivery-option]")) {
        if (input.classList.contains("is-selected")) options[position] = input.dataset.deliveryOption || "";
      } else if (input.matches("select")) {
        options[position] = input.value || "";
      }

      return options;
    }, []);
  }

  const matchingVariant = variants.find((variant) => {
    return selectedOptions.every((value, index) => {
      if (!value) return true;
      return normalizeOptionValue(variant.options[index]) === normalizeOptionValue(value);
    });
  });

  if (!matchingVariant) return;
  const idInput = form.querySelector('input[name="id"]');
  const submit = form.querySelector('button[type="submit"]');
  if (idInput) idInput.value = matchingVariant.id;
  if (submit) {
    submit.disabled = !matchingVariant.available;
    submit.textContent = matchingVariant.available ? "Add To Bag" : "Sold out";
  }

  const price = root.querySelector("[data-product-price]");
  if (price) price.innerHTML = buildMoneyHtml(matchingVariant);
}

function normalizeOptionValue(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/\s+/g, "")
    .replace(/nextday|1-3days|1,2,3days/g, "next")
    .replace(/3-5days/g, "3-5")
    .replace(/18-20days|18-21days/g, "18-20");
}

function buildMoneyHtml(variant) {
  const price = formatShopMoney(variant.price);
  const compareAt = variant.compare_at_price ? formatShopMoney(variant.compare_at_price) : "";
  if (compareAt && Number(variant.compare_at_price) > Number(variant.price)) {
    return `<s>${compareAt}</s> <strong>${price}</strong>`;
  }
  return price;
}

function formatShopMoney(value) {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return "";
  const amount = numericValue > 100000 ? numericValue / 100 : numericValue;
  return `Rs. ${Math.round(amount).toLocaleString("en-IN")}`;
}

function restoreBrandMomentCards() {
  const section = document.querySelector(".ff-home-moment");
  if (!section || section.querySelector("[src*='farlane-brand-ovo']")) return;
  if (!/Jil Sander|Golden Goose|Maison Margiela/.test(section.textContent || "")) return;

  const cards = [
    ["OVO", "/search?q=OVO", "//far-lane.com/cdn/shop/t/2/assets/farlane-brand-ovo.png"],
    ["Swatch", "/search?q=Swatch", "//far-lane.com/cdn/shop/t/2/assets/farlane-brand-swatch.png"],
    ["Yeezy", "/search?q=Yeezy", "//far-lane.com/cdn/shop/t/2/assets/farlane-brand-yeezy.png"],
  ];

  const grid = cards.map(([title, href, src]) => {
    return `<a href="${href}"><img src="${src}" alt="${title}" loading="lazy" width="1080" height="1440"><span>${title}</span></a>`;
  }).join("");

  section.innerHTML = `<h2>Brands of the moment</h2><div class="ff-home-moment__grid">${grid}</div>`;
}

function initHeroCarousels() {
  document.querySelectorAll("[data-hero-carousel]").forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll("[data-hero-slide]")).filter(function(s){return getComputedStyle(s).display !== "none";});
    if (slides.length < 2) return;
    const hero = carousel.closest(".ff-home-hero");
    const heading = hero ? hero.querySelector(".ff-home-hero__copy h1") : null;
    const text = hero ? hero.querySelector(".ff-home-hero__copy p") : null;
    const button = hero ? hero.querySelector(".ff-home-button") : null;

    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains("is-active")));
    slides.forEach((slide, index) => slide.classList.toggle("is-active", index === activeIndex));
    updateHeroCarouselCopy(carousel, slides[activeIndex], heading, text, button);

    window.setInterval(() => {
      slides[activeIndex].classList.remove("is-active");
      activeIndex = (activeIndex + 1) % slides.length;
      slides[activeIndex].classList.add("is-active");
      updateHeroCarouselCopy(carousel, slides[activeIndex], heading, text, button);
    }, 5000);
  });
}

function updateHeroCarouselCopy(carousel, slide, heading, text, button) {
  const title = slide.dataset.title || slide.alt || "";
  const copy = slide.dataset.text || "";
  const url = slide.dataset.url || carousel.href || "/collections/all";

  if (heading && title) heading.textContent = title;
  if (text && copy) text.textContent = copy;
  if (button) button.href = url;
  carousel.href = url;
  carousel.setAttribute("aria-label", title);
}

function initInfiniteScroll(){var nav=document.querySelector('[data-view-more][data-infinite-scroll]');if(!nav||!('IntersectionObserver' in window))return;var io=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){var link=document.querySelector('[data-view-more][data-infinite-scroll] [data-view-more-link]');if(link&&link.getAttribute('aria-busy')!=='true')link.click();}});},{rootMargin:'800px'});io.observe(nav);}
try{initInfiniteScroll();}catch(e){}
